/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './SegmentCrudRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#getSegmentByIdentifier
 */
export const GET_SEGMENT_BY_IDENTIFIER_QUERY_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_getSegmentByIdentifier';
export const GET_SEGMENT_BY_IDENTIFIER_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEGMENT_BY_IDENTIFIER_QUERY_FIELD_NAME,
  args: ['identifier'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSegmentByIdentifierRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#getSegmentsByIdentifiers
 */
export const GET_SEGMENTS_BY_IDENTIFIERS_QUERY_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_getSegmentsByIdentifiers';
export const GET_SEGMENTS_BY_IDENTIFIERS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEGMENTS_BY_IDENTIFIERS_QUERY_FIELD_NAME,
  args: ['identifiers'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSegmentsByIdentifiersRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#searchSegmentsOfType
 */
export const SEARCH_SEGMENTS_OF_TYPE_QUERY_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_searchSegmentsOfType';
export const SEARCH_SEGMENTS_OF_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SEARCH_SEGMENTS_OF_TYPE_QUERY_FIELD_NAME,
  args: ['query', 'pageLength', 'offset', 'segmentType'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.searchSegmentsOfTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#getIdentifiersOfType
 */
export const GET_IDENTIFIERS_OF_TYPE_QUERY_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_getIdentifiersOfType';
export const GET_IDENTIFIERS_OF_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_IDENTIFIERS_OF_TYPE_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset', 'segmentType'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getIdentifiersOfTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#getSegmentsOfType
 */
export const GET_SEGMENTS_OF_TYPE_QUERY_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_getSegmentsOfType';
export const GET_SEGMENTS_OF_TYPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SEGMENTS_OF_TYPE_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset', 'segmentType'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getSegmentsOfTypeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#createSegment
 */
export const CREATE_SEGMENT_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_createSegment';
export const CREATE_SEGMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_SEGMENT_MUTATION_FIELD_NAME,
  args: ['createRequirements', 'filters', 'segmentType', 'name', 'description'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.createSegmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#createSegments
 */
export const CREATE_SEGMENTS_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_createSegments';
export const CREATE_SEGMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: CREATE_SEGMENTS_MUTATION_FIELD_NAME,
  args: ['segments'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.createSegmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#updateSegment
 */
export const UPDATE_SEGMENT_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_updateSegment';
export const UPDATE_SEGMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SEGMENT_MUTATION_FIELD_NAME,
  args: ['identifier', 'filters', 'segmentType', 'name', 'description'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.updateSegmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#updateSegments
 */
export const UPDATE_SEGMENTS_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_updateSegments';
export const UPDATE_SEGMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UPDATE_SEGMENTS_MUTATION_FIELD_NAME,
  args: ['segments'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.updateSegmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#deleteSegment
 */
export const DELETE_SEGMENT_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_deleteSegment';
export const DELETE_SEGMENT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_SEGMENT_MUTATION_FIELD_NAME,
  args: ['identifier'],
  fetcher(request, ctx) {
    var _ctx$customClient10;
    return ((_ctx$customClient10 = ctx.customClient) !== null && _ctx$customClient10 !== void 0 ? _ctx$customClient10 : chirpClient).call(References.deleteSegmentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.segment.rpc.SegmentCrudRpc#deleteSegments
 */
export const DELETE_SEGMENTS_MUTATION_FIELD_NAME = 'com_hubspot_segment_rpc_SegmentCrudRpc_deleteSegments';
export const DELETE_SEGMENTS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DELETE_SEGMENTS_MUTATION_FIELD_NAME,
  args: ['identifiers'],
  fetcher(request, ctx) {
    var _ctx$customClient11;
    return ((_ctx$customClient11 = ctx.customClient) !== null && _ctx$customClient11 !== void 0 ? _ctx$customClient11 : chirpClient).call(References.deleteSegmentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});